import { Routes } from '@/config/routes';
import Button from '@/components/ui/button';
import Link from '@/components/ui/link';

interface Props {
  protocol?: number;
}

export default function DeliveryPartnerSuccess({ protocol }: Props) {
  return (
    <section
      className="mx-auto max-w-2xl rounded-3xl border border-border-base bg-light p-8 text-center sm:p-12"
      aria-live="polite"
    >
      <span className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-accent/10">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-8 w-8 text-accent"
          aria-hidden="true"
        >
          <path d="m5 12 5 5L20 7" />
        </svg>
      </span>

      <h2 className="mb-3 text-2xl font-bold text-heading sm:text-3xl">
        Candidatura enviada!
      </h2>

      <p className="mb-2 text-base text-body">
        Recebemos os seus dados. Nosso time analisa as candidaturas por ordem de
        chegada e entra em contato pelo telefone ou e-mail informados.
      </p>

      {protocol && (
        <p className="mb-6 text-sm text-body">
          Guarde o seu protocolo:{' '}
          <strong className="font-semibold text-heading">#{protocol}</strong>
        </p>
      )}

      <p className="mb-8 text-sm text-body">
        Não é preciso enviar o formulário novamente — cadastros duplicados não
        aceleram a análise.
      </p>

      <Link href={Routes.home}>
        <Button size="medium">Voltar para a página inicial</Button>
      </Link>
    </section>
  );
}
